<template>
  <!-- 单元格容器：适配移动端流式布局 -->
  <div class="cell-item" :style="{ padding: padding }">
    <!-- 左侧内容区 -->
    <div class="cell-left" :style="{ flex: leftFlex }">
      <!-- 左侧文本：支持v-html、超长省略号 -->
      <div
        class="cell-left__content"
        v-if="leftContent"
        :style="{
          fontSize: leftFontSize,
          color: leftColor,
          width: datas.commodityType == 4 ? '120px' : '100%',
        }"
      >
        {{ $utils.pureChineseText(leftContent) }}
      </div>
    </div>

    <!-- 右侧内容区 -->
    <div class="cell-right" :style="{ flex: rightFlex }">
      <!-- 右侧自定义内容（优先显示slot） -->
      <slot name="right">
        <!-- 默认右侧内容：支持v-html -->
        <div
          class="cell-right__content"
          v-if="rightContent"
          v-html="rightContent"
          :style="{ fontSize: rightFontSize, color: rightColor }"
        ></div>
      </slot>
      <!-- 右侧自定义图标 -->
      <div class="cell-right__icon" v-if="rightIcon">
        <i
          :class="rightIcon"
          :style="{ fontSize: rightIconSize, color: rightIconColor }"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomCellItem",
  props: {
    datas: {
      type: Object,
    },
    // 左侧内容（支持HTML）
    leftContent: {
      type: String,
      default: "",
    },
    // 左侧字体大小
    leftFontSize: {
      type: String,
      default: "12px",
    },
    // 左侧文本颜色
    leftColor: {
      type: String,
      default: "#333333",
    },
    // 新增：左侧文本显示行数（1=单行，>1=多行）
    leftLineClamp: {
      type: Number,
      default: 1,
      validator: (val) => val >= 1, // 限制行数≥1
    },
    // 右侧内容（支持HTML）
    rightContent: {
      type: String,
      default: "",
    },
    // 右侧字体大小
    rightFontSize: {
      type: String,
      default: "12px",
    },
    // 右侧文本颜色
    rightColor: {
      type: String,
      default: "#999999",
    },
    // 右侧图标类名（如iconfont的类名）
    rightIcon: {
      type: String,
      default: "",
    },
    // 右侧图标大小
    rightIconSize: {
      type: String,
      default: "16px",
    },
    // 右侧图标颜色
    rightIconColor: {
      type: String,
      default: "#cccccc",
    },
    // 单元格内边距（适配不同设计）
    padding: {
      type: String,
      default: "",
    },
    // 左侧内容区占比（flex值）
    leftFlex: {
      type: [Number, String],
      default: 1,
    },
    // 右侧内容区占比（flex值）
    rightFlex: {
      type: [Number, String],
      default: "none",
    },
  },
};
</script>

<style scoped>
/* 单元格基础样式：移动端适配 */
.cell-item {
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #f5f5f5; /* 底部分割线，可选 */
}

/* 左侧内容区：超长显示省略号 */
.cell-left {
  overflow: hidden;
}
.cell-left__content {
  line-height: 1.4;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 右侧内容区：横向排列，靠右对齐 */
.cell-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cell-right__content {
  white-space: nowrap; /* 右侧内容不换行 */
  line-height: 1.4;
}
.cell-right__icon {
  flex-shrink: 0; /* 图标不被压缩 */
  padding-top: 4px;
}

/* 适配iconfont */
.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
